import { Widget, WIDGET_RETAIL_ODDS_MULTI } from "@gaming/srvg-classes-core";


export class RetailOddsMultiWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#oddsWidget0';
        super(options);

        this.name = 'widgetretailoddsmulti';
        this.widgetName = options.widgetName || WIDGET_RETAIL_ODDS_MULTI;
        this.widgetName = this.product + this.widgetName;


        this.widget = null;

        this.widgetOptions = {
            'widgetGroup' : '',
            'platform' : "desktop-small",
            'zoomPosition' : "default",
            'showFixtures' : true,
            'showMatchIds' : true,
            'showSeasonMatchday' : false,
            'showTeamAbbr' : false,
            'showLockIcon' : true,
            'showSpecialInHeader' : true,
            'widths' : ["448px","352px","352px","235px","235px","235px"],
            selectedMarkets: {
                'fulltimeresult': [],
                'halftimeresult': [],
                'totalgoals': {
                    '0': [
                        "1.5"
                    ],
                    '1': [
                        "1.5"
                    ],
                    '2': [
                        "1.5"
                    ]
                }
            },
            'matchIds' : [],
            'marketGap' : '3px'
        };
        this.widgetOptions['height'] = this.getContainerHeightWithUnit();

        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        if (this.widgetOptions['height'] == 0) {
            this.widgetOptions['height'] = '300px';//this.getContainerHeightWithUnit();
        }
        else {
            this.widgetOptions['height'] = this.getContainerHeightWithUnit();
        }
        //console.log(this.widgetOptions['height']);
        this.addRetailOddsMultiWidget();
        super.handleDomInstantiated();
    }

    /**
     * add retail odds multi widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addRetailOddsMultiWidget(selector?) {
        var that = this;
        selector = selector || this.selector;
        /* console.log(selector);
         console.log(this.widgetName);
         console.log(this.widgetOptions);
        */
        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addRetailOddsMultiWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addRetailOddsMultiWidget(element);
    }

    /**
     * calls widget api setChannel to switch channel
     * it is not necessary to switch the channel if livescore widget is connected with widget via widget group
     * @param number channel equivalent to videochannel
     */
    /*  setChannel(channel?: number){
          if(this.widget.api){
              this.widget.api.setChannel(channel);
          }
      }*/
}